import { ReactElement } from 'react'

import { IR_LIBRARY_ROUTE } from '@/utils/enroutes'

import { LinkCard } from '@/components/elements/LinkCard'
import { LinkCardList } from '@/components/elements/LinkCardList'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Layout } from '@/components/enlayouts/Ir'
import { DownloadZipButton } from '@/components/enlayouts/Ir/Mpocket/DownloadZipButton'

import { useMpocketScript } from '@/hooks/useMpocketScript'

export const IrLibraryPage = () => {
  useMpocketScript('//irpocket.com/141A/irpocket/config-utils-main_en.js')
  // useMpocketScript('//irpocket.com/5882/irpocket/config-utils-main_en.js')

  return (
    <Layout>
      <SectionTitle
        color="normal"
        enTitleText="IR Library"
        subTitleText=""
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <LinkCardList>
        {IR_LIBRARY_ROUTE.subdirectories.map(
          ({ path, name, imagePath, ...other }) => (
            <LinkCard
              link={path}
              title={name}
              imgPath={imagePath}
              {...other}
              key={path}
            />
          )
        )}
      </LinkCardList>
      <Spacer h={{ sp: 26, pc: 46 }} />
      <DownloadZipButton id="irp-library-latest-zip" />
    </Layout>
  )
}
IrLibraryPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Investor Relations', path: '/en/ir' },
    { name: 'IR Library', path: '' },
  ]

  return (
    <>
      <Head
        title="IR Library"
        description="IR Library"
        ogp={{ url: 'en/ir/library/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle=""
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
